import { defineStore } from 'pinia'
import { DocumentationService } from '../documentation/DocumentationService.js'
import { SearchService } from '../documentation/SearchService.js'

export const useDocumentationStore = defineStore('documentation', {
  state: () => ({
    index: [],
    navigation: {},
    currentDoc: null,
    loading: false,
    error: null,
    searchResults: [],
    searchQuery: '',
    indexLoaded: false,
  }),

  actions: {
    async loadIndex() {
      if (this.indexLoaded) return
      this.loading = true
      this.error = null
      try {
        this.index = await DocumentationService.fetchIndex()
        this.navigation = await DocumentationService.getNavigation()
        SearchService.buildIndex(this.index)
        this.indexLoaded = true
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },

    async openDocument(id) {
      this.loading = true
      this.error = null
      try {
        if (!this.indexLoaded) await this.loadIndex()
        this.currentDoc = await DocumentationService.getDocument(id)
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },

    async openByContext(context) {
      this.loading = true
      this.error = null
      try {
        if (!this.indexLoaded) await this.loadIndex()
        this.currentDoc = await DocumentationService.getByContext(context)
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },

    search(query) {
      this.searchQuery = query
      if (!query.trim()) {
        this.searchResults = []
        return
      }
      this.searchResults = SearchService.search(query)
    },

    clearSearch() {
      this.searchQuery = ''
      this.searchResults = []
    },
  },
})
